import Replacement from './replacement';
import BlockRange from '@intercom/embercom-composer/blocks/block-range';
import Em from 'ember';
export default Replacement.extend().reopenClass({
  _doInlineReplacement(block, regex, entityType, captureGroupMapping, mutationResult) {
    regex = new RegExp(regex);
    let originalBlockText, newBlockText, match, startIndex, endIndex, fullMatch;
    let entityProperties = {};
    let accumulatedOffset = 0; // As we perform the replacements the match index will shift if the replacement is a different length to what's replaced
    originalBlockText = block.get('text');
    let replacementCount = 0;
    let newEntityRange;
    while (match = regex.exec(originalBlockText)) {
      replacementCount++;
      newBlockText = block.get('text');
      fullMatch = match.shift();
      for (let i = 0; i < match.length; i++) {
        entityProperties[captureGroupMapping[i]] = match[i];
      }
      entityProperties.text = entityProperties.text || '';
      startIndex = match.index + accumulatedOffset;
      endIndex = startIndex + entityProperties.text.length;
      newEntityRange = BlockRange.atPositionIndex(startIndex, endIndex);
      if (existingEntitiesOfTypeInRange(block, entityType, newEntityRange)) {
        //eslint-disable-next-line no-continue
        continue;
      }
      accumulatedOffset += entityProperties.text.length - fullMatch.length;
      newBlockText = newBlockText.replace(fullMatch, function () {
        return entityProperties.text;
      });
      block.set('text', newBlockText);
      block._updateEntitiesAfterInlineReplacement(startIndex, fullMatch.length, entityProperties.text.length);
      block.addEntity(entityType, newEntityRange, entityProperties);
      if (mutationResult) {
        updateMutationResult(mutationResult, startIndex, fullMatch, entityProperties.text);
      }
    }
    return replacementCount;
  }
});
function existingEntitiesOfTypeInRange(block, entityType, range) {
  return Em.isPresent(block.get('entities').byTypeCoveringRange(entityType, range));
}
function updateMutationResult(mutationResult, matchStartIndex, match, replacement) {
  let blockRange = mutationResult.get('blockRange');
  if (blockRange) {
    let startIndex = blockRange.get('startPoint.positionIndex');
    let changesLeftOfRange = getLengthDiff(startIndex, matchStartIndex, match, replacement);
    blockRange.shiftLeftBy(changesLeftOfRange);
  }
}
function getLengthDiff(startIndex, matchIndex, match, replacement) {
  let mappedIndex = startIndex - matchIndex;
  let lengthDiff = match.length - replacement.length;
  // Caret is left of the match, so there is no diff
  if (mappedIndex <= 0) {
    return 0;
  }
  // Caret is right of the match, so diff is just the overall length diff
  if (mappedIndex > match.length) {
    return lengthDiff;
  }
  //Caret is somewhere in the match, iterate over and find the diff left of cursor
  let i, j, diff;
  i = j = diff = 0;
  while (i < mappedIndex) {
    if (match.charAt(i) !== replacement.charAt(j)) {
      diff++;
    } else {
      j++;
    }
    i++;
  }
  //If for some reason the character by character diff is too big, all we can do is assume it's the length diff
  if (diff > lengthDiff) {
    diff = lengthDiff;
  }
  return diff;
}